const alunosTurma = [
  //TURMA 1
  {
    turma: 'Turma 1',
    info: [
      {
        name: 'Bruno R. Rodrigues',
        img_profile: 'assets/img/turma1/bruno.png',
        linkGit: '#',
      },
      {
        name: 'Eduardo A. Araújo',
        img_profile: 'assets/img/turma1/eduardo.png',
        linkGit: '#',
      },
      {
        name: 'Gabriel B. Cerquinho',
        img_profile: 'assets/img/turma1/gabriel.png',
        linkGit: '#',
      },
      {
        name: 'Gleides Silva',
        img_profile: 'assets/img/turma1/gleides.png',
        linkGit: '#',
      },
      {
        name: 'Gutemberg B. Ferreira',
        img_profile: 'assets/img/turma1/gutemberg.jpeg',
        linkGit: 'https://www.linkedin.com/in/gutembergbritoferreira/',
      },
      {
        name: 'Jeison P. Oliveira',
        img_profile: 'assets/img/turma1/jeison.png',
        linkGit: '#',
      },
      {
        name: 'Jonathas B. Cavalcante',
        img_profile: 'assets/img/turma1/jonathas.png',
        linkGit: 'https://www.linkedin.com/in/jonathascavalcante',
      },
      {
        name: 'José Alberto Filho',
        img_profile: 'assets/img/turma1/jose.png',
        linkGit: 'https://www.linkedin.com/in/jose-alberto',
      },
      {
        name: 'José Rodrigues',
        img_profile: 'assets/img/turma1/mateus.png',
        linkGit: 'https://www.linkedin.com/in/jose-mateus-cordova-rodrigues/',
      },
      {
        name: 'Josias B. F. Cavalcante',
        img_profile: 'assets/img/turma1/josias.png',
        linkGit: 'https://www.linkedin.com/in/josiascavalcante/ ',
      },
      {
        name: 'Josué Lustosa Filho',
        img_profile: 'assets/img/turma1/josue.png',
        linkGit: 'https://www.linkedin.com/in/josue-lustosa/',
      },
      {
        name: 'Laura Lima Guedes',
        img_profile: 'assets/img/turma1/laura.png',
        linkGit: '#',
      },
      {
        name: 'Nathália R. M. Santos',
        img_profile: 'assets/img/turma1/nathalia.png',
        linkGit: 'https://www.linkedin.com/in/nathalia-santos-ns27/',
      },
      {
        name: 'Paula Mendonça',
        img_profile: 'assets/img/turma1/paula.png',
        linkGit: 'https://www.linkedin.com/in/paula-quadros',
      },
      {
        name: 'Shermam Lima',
        img_profile: 'assets/img/turma1/shermam.png',
        linkGit: 'https://www.linkedin.com/in/shermam-t%C3%A1cia-0378a8152/',
      },
      {
        name: 'Solano Lima Oliveira',
        img_profile: 'assets/img/turma1/solano.png',
        linkGit: 'https://www.linkedin.com/in/solano-lima-oliveira-146b23188/',
      },
      {
        name: 'Taynara Costa',
        img_profile: 'assets/img/turma1/taynara.png',
        linkGit: 'https://www.linkedin.com/in/taynara-costa-944798198/',
      },
    ],
  },

  //TURMA 2
  {
    turma: 'Turma 2',
    info: [
      {
        name: 'Adriano  Gomes',
        img_profile: 'assets/img/turma2/adriano.jpeg',
        linkGit: 'https://www.linkedin.com/in/adriano-gomes-9b1779186/',
      },
      {
        name: 'Antônio José Neto',
        img_profile:
          'https://ca.slack-edge.com/T052KR1029Y-U05MBSATXMM-872a35a66d02-512',
        linkGit: 'https://www.linkedin.com/in/antonio-fernandes-19287325/',
      },

      {
        name: 'Aris Canto',
        img_profile:
          'https://ca.slack-edge.com/T052KR1029Y-U05MKP8S30E-26a8d4f035bb-512',
        linkGit: '#',
      },
      {
        name: 'Caio Fernandes',
        img_profile:
          'https://ca.slack-edge.com/T052KR1029Y-U05NG3ZSDPS-4c5769619cee-512',
        linkGit: 'https://www.linkedin.com/in/caio-fernandes-965196209/',
      },
      {
        name: 'Caroline Braz',
        img_profile: 'assets/img/turma2/carol.jpg',
        linkGit: 'https://www.linkedin.com/in/caroline-braz-43961b146/',
      },
      {
        name: 'Crislan Rodrigues Cruz',
        img_profile: 'assets/img/turma2/crislan.jpg',
        linkGit: 'https://www.linkedin.com/in/crislancruz',
      },
      {
        name: 'Daniel Antunes Ribeiro',
        img_profile:
          'https://ca.slack-edge.com/T052KR1029Y-U05MPF7SL6R-824484f7c933-512',
        linkGit: 'https://www.linkedin.com/in/daniel-antunes-ribeiro',
      },
      {
        name: 'Eduardo Silva',
        img_profile: 'assets/img/turma2/eduardo.jpg',
        linkGit: '#',
      },
      {
        name: 'Eduardo Noji',
        img_profile:
          'https://ca.slack-edge.com/T052KR1029Y-U05MS9WJS67-62a81a5b510a-512',
        linkGit: 'https://www.linkedin.com/in/eduardonoji/',
      },
      {
        name: 'Francisco Gabriel',
        img_profile:
          'https://ca.slack-edge.com/T052KR1029Y-U05MSCQ5BH8-e0218ae3bca9-512',
        linkGit: 'https://www.linkedin.com/in/francisco-gabriel-software/',
      },
      {
        name: 'Gabriel Sobrinho',
        img_profile:
          'https://ca.slack-edge.com/T052KR1029Y-U05N51YGTMX-75f78d6bb02d-512',
        linkGit: '#',
      },
      {
        name: 'Gabriel Amoêdo',
        img_profile:
          'https://ca.slack-edge.com/T052KR1029Y-U05346W0E2D-c7b106c98540-512',
        linkGit: 'https://www.linkedin.com/in/gabriel-amo%C3%AAdo-a1b078a7',
      },
      {
        name: 'Ícaro Santos',
        img_profile: 'https://avatars.githubusercontent.com/u/46682140?v=4',
        linkGit: 'https://www.linkedin.com/in/icarosun',
      },
      {
        name: 'Luiz Gustavo Arruda',
        img_profile: 'assets/img/turma2/luiz.jpg',
        linkGit: 'https://www.linkedin.com/in/luiz-gustavo-arruda-15703194',
      },
      {
        name: 'Noah Diunkz',
        img_profile: 'https://avatars.githubusercontent.com/u/18603573?v=4',
        linkGit: 'https://br.linkedin.com/in/diunkz',
      },
      {
        name: 'Salomão Cruz',
        img_profile: 'assets/img/turma2/salomao.jpg',
        linkGit: 'https://www.linkedin.com/in/salomao-cruz/',
      },
      {
        name: 'Sidney Araújo',
        img_profile:
          'https://ca.slack-edge.com/T052KR1029Y-U05MPFVHSE9-ff36e601d52e-512',
        linkGit:
          'https://www.linkedin.com/in/sidney-de-araujo-fonseca-20414493',
      },
      {
        name: 'Vitor Xavier',
        img_profile: 'assets/img/turma2/vitor.jpg',
        linkGit: '#',
      },
      {
        name: 'Vitória Beatriz',
        img_profile: 'https://avatars.githubusercontent.com/u/91225063?v=4',
        linkGit: 'https://www.linkedin.com/in/vit%C3%B3ria-beatriz-324481224',
      },
    ],
  },

  //TURMA 3
  {
    turma: 'Turma 3',
    info: [
      {
        name: 'Allan Aguiar',
        img_profile: 'assets/img/turma3/allan.png',
        linkGit: 'https://www.linkedin.com/in/allan-carvalho-687056192',
      },
      {
        name: 'Ayrton Lemes',
        img_profile: 'assets/img/turma3/ayrton.png',
        linkGit: 'http://www.linkedin.com/in/ayrton-finicelli-lemes-9b4481225',
      },

      {
        name: 'Brenda Moura',
        img_profile: 'assets/img/turma3/brenda.jpeg',
        linkGit: 'https://www.linkedin.com/in/brenda-cd-moura/',
      },
      {
        name: 'Cáio Gonzaga',
        img_profile: 'assets/img/turma3/caio.png',
        linkGit: 'http://linkedin.com/in/caio-cesar-b66910242',
      },
      {
        name: 'Daniele Greice',
        img_profile: 'assets/img/turma3/daniele.jpeg',
        linkGit: 'https://www.linkedin.com/in/daniele-greice-00b484186/',
      },
      {
        name: 'Davi Souza',
        img_profile: 'assets/img/turma3/davi.jpeg',
        linkGit: 'https://www.linkedin.com/in/davi-souza-5057901b3/',
      },
      {
        name: 'Gabriel Freitas',
        img_profile: 'assets/img/turma3/gabrielF.png',
        linkGit: 'http://www.linkedin.com/in/gabriel-freitas-507baa274',
      },
      {
        name: 'Gabriel Pacheco',
        img_profile: 'assets/img/turma3/gabrielP.png',
        linkGit: 'https://www.linkedin.com/in/gabrielspc/',
      },
      {
        name: 'Girlana Santos',
        img_profile: 'assets/img/turma3/girlana.png',
        linkGit: 'https://www.linkedin.com/in/girlana-souza-041200220/',
      },
      {
        name: 'Isabella Mendes',
        img_profile: 'assets/img/turma3/isabella.png',
        linkGit: 'https://www.linkedin.com/in/isabella-negr%C3%A3o-7b3899133/',
      },
      {
        name: 'Max Souza',
        img_profile: 'assets/img/turma3/max.jpeg',
        linkGit: 'http://www.linkedin.com/in/max-souza-4533b6196',
      },
      {
        name: 'Natanael de Oliveira',
        img_profile: 'assets/img/turma3/natanael.jpeg',
        linkGit: 'https://www.linkedin.com/in/natanael-bezerra/',
      },
      {
        name: 'Rodrigo Santos',
        img_profile: 'assets/img/turma3/rodrigo.jpeg',
        linkGit: 'https://www.linkedin.com/in/rodrigosc/',
      },
      {
        name: 'Saile Costa',
        img_profile: 'assets/img/turma3/saile2.png',
        linkGit: 'https://www.linkedin.com/in/saile-santos/',
      },
      {
        name: 'Thiago Oliveira',
        img_profile: 'assets/img/turma3/tiago.png',
        linkGit: 'https://www.linkedin.com/in/thiago-de-oliveira-899664b0',
      },
      {
        name: 'Vinicius Fonseca',
        img_profile: 'assets/img/turma3/vinicius.png',
        linkGit:
          'https://www.linkedin.com/in/vinicius-luiz-nunes-da-fonseca-250aa9272/',
      },
    ],
  },

  //TURMA 4
  {
    turma: 'Turma 4',
    info: [
      {
        name: 'Adriano Nobre',
        img_profile: 'assets/img/turma4/adriano.jpeg',
        linkGit: 'https://www.linkedin.com/in/adrianobre/',
      },
      {
        name: 'Beatriz Aguiar',
        img_profile: 'assets/img/turma4/beatriz.jpeg',
        linkGit: 'https://www.linkedin.com/in/beatriz-aguiar-821b40241/',
      },
      {
        name: 'Bruno Solimões',
        img_profile: 'assets/img/turma4/bruno.jpeg',
        linkGit:
          'https://www.linkedin.com/in/bruno-de-moura-solim%C3%B5es-455523177/',
      },
      {
        name: 'Charlene Queiroz',
        img_profile: 'assets/img/turma4/charlene.jpeg',
        linkGit: '',
      },
      {
        name: 'Cristian Garcia',
        img_profile: 'assets/img/turma4/cristian.png',
        linkGit: 'https://www.linkedin.com/in/cristian-garcia-web/',
      },
      {
        name: 'Daniel Leal',
        img_profile: 'assets/img/turma4/daniel.jpeg',
        linkGit: 'https://www.linkedin.com/in/dan-leal/',
      },
      {
        name: 'Ecthon Almeida',
        img_profile: 'assets/img/turma4/ecthon.jpeg',
        linkGit: 'https://www.linkedin.com/in/ecthon/',
      },
      {
        name: 'Eduardo Okita',
        img_profile: 'assets/img/turma4/okita.png',
        linkGit: 'https://www.linkedin.com/in/eduardo-okita/',
      },
      {
        name: 'Erik Lima',
        img_profile: 'assets/img/turma4/erik.jpeg',
        linkGit: 'https://www.linkedin.com/in/erik-gustavo-oliveira-71034a204/',
      },
      {
        name: 'Fílip Anselmo',
        img_profile: 'assets/img/turma4/filip.jpeg',
        linkGit: 'https://www.linkedin.com/in/filip-anselmo-04b651152/',
      },
      {
        name: 'Francisco Júnior',
        img_profile: 'assets/img/turma4/francisco.jpeg',
        linkGit: 'https://www.linkedin.com/in/francisco-rivail-8703961a0/',
      },
      {
        name: 'Franklin Rosevelt',
        img_profile: 'assets/img/turma4/franklin.jpeg',
        linkGit:
          'https://www.linkedin.com/in/franklin-roosevelt-xavier-dantas-180804311/',
      },
      {
        name: 'Ítalo Pinheiro',
        img_profile: 'assets/img/turma4/italo.png',
        linkGit: 'https://www.linkedin.com/in/italo-feitosa-pinheiro/',
      },
      {
        name: 'José Lázaro',
        img_profile: 'assets/img/turma4/lazaro.jpeg',
        linkGit:
          'https://www.linkedin.com/in/jos%C3%A9-l%C3%A1zaro-marques-28075030a/',
      },
      {
        name: 'Kristine Santana',
        img_profile: 'assets/img/turma4/kristine.jpeg',
        linkGit: 'https://www.linkedin.com/in/kristine-santana/',
      },
      {
        name: 'Marcos Rebelo',
        img_profile: 'assets/img/turma4/marcos.jpeg',
        linkGit: 'https://www.linkedin.com/in/marcos-guerreiro-rebelo/',
      },
      {
        name: 'Matheus Oliveira',
        img_profile: 'assets/img/turma4/matheus.jpeg',
        linkGit: 'https://www.linkedin.com/in/matheusouzaoliveira/',
      },
      {
        name: 'Rafael Carvalho',
        img_profile: 'assets/img/turma4/raphael.jpeg',
        linkGit: '#',
      },
      {
        name: 'Rodrigo Queiroz',
        img_profile: 'assets/img/turma4/rodrigo.jpeg',
        linkGit: 'https://www.linkedin.com/in/rodnobr/',
      },
      {
        name: 'Suelen Pereira',
        img_profile: 'assets/img/turma4/suellen.jpeg',
        linkGit: '#',
      },
      {
        name: 'Thiago Martins',
        img_profile: 'assets/img/turma4/thiago.png',
        linkGit: 'https://www.linkedin.com/in/thiagomartins05/',
      },
    ],
  },
  {
    turma: 'Turma 5',
    info: [
      {
        name: 'Alexander Nascimento',
        img_profile: 'assets/img/turma5/alexander.png',
        linkGit: 'https://www.linkedin.com/in/alexander-nascimento-852156205/',
      },
      {
        name: 'Alleck Santos',
        img_profile: 'assets/img/turma5/alleck.png',
        linkGit: 'https://www.linkedin.com/in/alleckluka/',
      },
      {
        name: 'Cláudio Guimarães',
        img_profile: 'assets/img/turma5/claudio.jpeg',
        linkGit: 'https://www.linkedin.com/in/claudio-albano-guimaraes',
      },
      {
        name: 'Priscilla Aragão',
        img_profile: 'assets/img/turma5/cleyci.png',
        linkGit: 'https://br.linkedin.com/in/priaragao',
      },
      {
        name: 'Davi Barreto',
        img_profile: 'assets/img/turma5/barreto.png',
        linkGit: 'https://www.linkedin.com/in/davi-coelho-0a44a0149/',
      },
      {
        name: 'Ewerton Petillo',
        img_profile: 'assets/img/turma5/ewerton.jpeg',
        linkGit: 'https://www.linkedin.com/in/ewerton-petillo-836707191',
      },
      {
        name: 'Gabriel Paiva',
        img_profile: 'assets/img/turma5/paiva.png',
        linkGit: '#',
      },
      {
        name: 'Gideão Sampaio',
        img_profile: 'assets/img/turma5/gideao.png',
        linkGit: 'https://www.linkedin.com/in/gideao-ximenes/',
      },
      {
        name: 'Hugo Moraes',
        img_profile: 'assets/img/turma5/hugo.png',
        linkGit: 'https://www.linkedin.com/in/hugomoraesbrasil',
      },
      {
        name: 'Josival Salvador',
        img_profile: 'assets/img/turma5/josival.png',
        linkGit: 'https://www.linkedin.com/in/josival-salvador-1936692a3/',
      },
      {
        name: 'Juan Santos',
        img_profile: 'assets/img/turma5/juan.png',
        linkGit: 'https://www.linkedin.com/in/juan-santos-96ab98235/',
      },
      {
        name: 'Luiz Sena',
        img_profile: 'assets/img/turma5/luiz_sena.jpeg',
        linkGit:
          'https://www.linkedin.com/in/luiz-gabriel-antunes-sena-b97841386/',
      },
      {
        name: 'Messyas Goes',
        img_profile: 'assets/img/turma5/messyas.png',
        linkGit: 'https://www.linkedin.com/in/messyas/',
      },
      {
        name: 'Renato Lousan',
        img_profile: 'assets/img/turma5/renato.png',
        linkGit: 'https://www.linkedin.com/in/renato-l-2bb8429a/',
      },
      {
        name: 'Ricardo Nogueira',
        img_profile: 'assets/img/turma5/nogueira.jpeg',
        linkGit: 'https://www.linkedin.com/in/ricardo-nm-filho/',
      },
      {
        name: 'Talita Ferreira',
        img_profile: 'https://avatars.githubusercontent.com/u/60278180?v=4',
        linkGit: 'https://www.linkedin.com/in/talitafesan',
      },
      {
        name: 'Tedy Prist',
        img_profile: 'assets/img/turma5/tedy.png',
        linkGit: 'https://www.linkedin.com/in/tedyprist/',
      },
      {
        name: 'Vanderson Cardoso',
        img_profile: 'assets/img/turma5/vanderson.png',
        linkGit: 'http://linkedin.com/in/van-card07',
      },
      {
        name: 'Vinivius Silveira',
        img_profile: 'assets/img/turma5/vinicius.png',
        linkGit: 'https://www.linkedin.com/in/vinicius-silveira-8079392b6',
      },
    ],
  },
  {
    turma: 'Turma 1 - EaD',
    info: [
      {
        name: 'Alfredo Barros',
        img_profile: 'assets/img/turma1_ead/alfredo.jpeg',
        linkGit: '#',
      },
      {
        name: 'Alícia Caldeiras',
        img_profile: 'assets/img/turma1_ead/alicia.jpeg',
        linkGit: 'https://www.linkedin.com/in/alicia-caldeira-b0a665264/',
      },
      {
        name: 'Antônio Alberto',
        img_profile: 'assets/img/turma1_ead/antonio.jpeg',
        linkGit: '#',
      },
      {
        name: 'Daniele Vasconcelos',
        img_profile: 'assets/img/turma1_ead/daniele.png',
        linkGit: '#',
      },
      {
        name: 'Felipe Barbosa',
        img_profile: 'assets/img/turma1_ead/felipe.png',
        linkGit: '#',
      },
      {
        name: 'Felipe Martins',
        img_profile: 'assets/img/turma1_ead/felipe_martins.jpeg',
        linkGit: 'https://www.linkedin.com/in/felipe-nascimento-4657bb28a/',
      },
      {
        name: 'Geison Brandão',
        img_profile: 'assets/img/turma1_ead/geison.png',
        linkGit: '#',
      },
      {
        name: 'Kássia Ramos',
        img_profile: 'assets/img/turma1_ead/kassia.png',
        linkGit: 'https://www.linkedin.com/in/kassia-ramos-oliveira-291969254/',
      },
      {
        name: 'Marcos Jhollyfer',
        img_profile: 'assets/img/turma1_ead/marcos.jpeg',
        linkGit: 'https://www.linkedin.com/in/jhollyferr/',
      },
      {
        name: 'Rennan Alves',
        img_profile: 'assets/img/turma1_ead/rennan.png',
        linkGit: '#',
      },
      {
        name: 'Waleson Melo',
        img_profile: 'assets/img/turma1_ead/waleson.jpeg',
        linkGit: 'https://www.linkedin.com/in/waleson-melo-7a4731197/',
      },
    ],
  },
   {
    turma: 'Turma 6',
    info: [
      {
        name: 'Bianka Maciel ',
        img_profile: 'assets/img/turma6/bianka.png',
        linkGit: 'https://www.linkedin.com/in/biankavmaciel/',
      },
      {
        name: 'Carlos Junior ',
        img_profile: 'assets/img/turma6/carlos.png',
        linkGit: 'https://www.linkedin.com/in/carlosandreslosada/',
      },
      {
        name: 'Deméthrius Rodrigues',
        img_profile: 'assets/img/turma6/dhemetrius.png',
        linkGit: 'https://www.linkedin.com/in/demethriusrodrigues/',
      },
      {
        name: 'Gabriel Iuji',
        img_profile: 'assets/img/turma6/iuji.png',
        linkGit: 'https://www.linkedin.com/in/gabriel-iuji-322729294/',
      },
      {
        name: 'Guilherme Sahdo',
        img_profile: 'assets/img/turma6/guilherme.png',
        linkGit: 'https://www.linkedin.com/in/guilherme-sahdo-207171236/',
      },
      {
        name: 'Helder Sena',
        img_profile: 'assets/img/turma6/helder.png',
        linkGit: '#',
      },
      {
        name: 'Jakeline Gimaque',
        img_profile: 'assets/img/turma6/jakeline.png',
        linkGit: 'https://www.linkedin.com/in/jakeline-g-mesquita/',
      },
      {
        name: 'Jhean Carllos',
        img_profile: 'assets/img/turma6/jhean.png',
        linkGit: 'https://www.linkedin.com/in/jhean-carlos/',
      },
      {
        name: 'João Guedes',
        img_profile: 'assets/img/turma6/joao.png',
        linkGit: 'http://linkedin.com/in/jjoao-guedes/',
      },
      {
        name: 'Kaike Maciel',
        img_profile: 'assets/img/turma6/kaike.png',
        linkGit: 'https://www.linkedin.com/in/kaikermaciel/',
      },
      {
        name: 'Lucas Darcio',
        img_profile: 'assets/img/turma6/lucas.png',
        linkGit: 'https://www.linkedin.com/in/lucas-darcio-64a150215/',
      },
      {
        name: 'Marcello Cipriano',
        img_profile: 'assets/img/turma6/marcelo.png',
        linkGit: '#',
      },
      {
        name: 'Matheus Pinheiro',
        img_profile: 'assets/img/turma6/matheus.png',
        linkGit: 'https://www.linkedin.com/in/matheus-pinheiro0597/',
      },
      {
        name: 'Mathias Teixeira',
        img_profile: 'assets/img/turma6/mathias.png',
        linkGit: 'https://www.linkedin.com/in/mathias-g-g-teixeira/',
      },
      {
        name: 'Micael Viana',
        img_profile: 'assets/img/turma6/micael.png',
        linkGit: 'https://www.linkedin.com/in/micael-viana-800950225/',
      },
      {
        name: 'Richard Oliveira',
        img_profile: 'assets/img/turma6/richard.png',
        linkGit: 'https://www.linkedin.com/in/richard-pyx/',
      },
      {
        name: 'Sabrina Caldas',
        img_profile: 'assets/img/turma6/sabrina.png',
        linkGit: 'https://www.linkedin.com/in/sabrina-caldas-a4b6421b7/',
      },
      {
        name: 'Sahil Dowlani',
        img_profile: 'assets/img/turma6/sahil.png',
        linkGit: 'https://www.linkedin.com/in/sahil-dowlani/',
      },
    ],
  },
];

export default alunosTurma;
